import {Flex, Text, TextProps} from '@chakra-ui/react';
import {useTranslation} from 'hooks';
import {FC} from 'react';
import {removeDecimals} from 'utils/strings';

interface Props {
  value: number | string;
  priceProps?: TextProps;
  showTextPrice?: boolean;
}

export const Price: FC<Props> = ({value, priceProps, showTextPrice}) => {
  const {t} = useTranslation();

  const finalValue = removeDecimals(Number(value));

  return (
    <Flex display="inline-flex" justify="space-between" fontSize="inherit">
      <Text className="price" fontWeight={600} {...priceProps}>
        {showTextPrice ? t('order') : `${finalValue === '' ? 0 : finalValue} ${t('CURRENCY')}`}
      </Text>
    </Flex>
  );
};
